import {
  SCENE_HIDE_MEASUREMENTS,
  SCENE_SHOW_MEASUREMENTS,
  SCENE_SET_PROPPING_VISIBILITY,
  SCENE_SET_ROOM,
  SCENE_SET_WALL_RESIZER_ACTIVE,
  SCENE_SET_WALL_RESIZER_INACTIVE,
  SCENE_SET_WALL_RESIZER_DRAGGING,
  SCENE_SET_RECT,
  SCENE_SET_MARGINS,
  PRODUCT_MENU_SET_FILTER,
  TAC_LOAD,
  SCENE_SHOW_SHEET,
  SCENE_HIDE_SHEET,
  SCENE_SET_PRELOAD_STATE,
} from '../actionConstants';
import defaultState from './sceneDefaultState';
import { Scene } from './sceneTypes';

export default (state: Scene = defaultState, action: any) => {
  switch (action.type) {
    case SCENE_SET_ROOM:
      return {
        ...state,
        room: { ...state.room, ...action.payload },
      };
    case SCENE_SET_RECT:
      return {
        ...state,
        room: { ...state.room, sceneRect: action.payload },
      };
    case SCENE_SET_MARGINS:
      return {
        ...state,
        room: { ...state.room, margins: action.payload },
      };
    case SCENE_HIDE_MEASUREMENTS:
      return {
        ...state,
        measurementsActive: false,
      };
    case SCENE_SHOW_MEASUREMENTS:
      return {
        ...state,
        measurementsActive: true,
      };
    case SCENE_SET_PROPPING_VISIBILITY:
      return {
        ...state,
        showPropping: action.payload.showPropping,
      };
    case SCENE_SET_WALL_RESIZER_ACTIVE:
      return {
        ...state,
        wallResizerActive: true,
      };
    case SCENE_SET_WALL_RESIZER_INACTIVE: {
      return {
        ...state,
        wallResizerActive: false,
      };
    }
    case SCENE_SET_WALL_RESIZER_DRAGGING:
      return {
        ...state,
        draggingWallResizer: action.payload.draggingWallResizer,
      };
    case PRODUCT_MENU_SET_FILTER: {
      const manualPortraitChange =
        !action.meta?.nonInteraction && action.meta?.isPortrait;
      return {
        ...state,
        measurementsActive: manualPortraitChange
          ? false
          : state.measurementsActive,
        wallResizerActive: manualPortraitChange
          ? false
          : state.wallResizerActive,
      };
    }
    case TAC_LOAD:
      return {
        ...state,
        showPropping: true,
      };

    case SCENE_SHOW_SHEET:
      return {
        ...state,
        sceneSheet: {
          showSceneSheet: true,
          sceneSheetModel: action.payload.sheetType,
        },
      };

    case SCENE_SET_PRELOAD_STATE:
      return {
        ...state,
        preloadDone: action.payload.preloadState,
      };

    case SCENE_HIDE_SHEET:
      return {
        ...state,
        sceneSheet: {
          showSceneSheet: false,
          sceneSheetModel: '',
        },
      };

    default:
      return state;
  }
};
